import { EMedicalCategoryType } from '@/entities/medical-category';
import { getCategoryPath } from '@/entities/telemedicine';
import { ROUTES } from '@/types/common';
import { addQueryString } from '@/utils/url';
import {
  DEFAULT_ACNE_TREATMENT_MEDICINE_UNIT_ID,
  DEFAULT_DIET_TREATMENT_MEDICINE_UNIT_ID,
  DEFAULT_HAIR_LOSS_TREATMENT_MEDICINE_UNIT_ID,
  SEOUL_REGION_CODE,
} from '../../entities/hospital/constant';
import { TELEMEDICINE_CATEGORY_IDS } from '../category';
import { TREATMENT_CATEGORIES_IDS } from '../category';

export enum FEATURE_FLAG {}

export const SIX_HOURS_IN_MILLISECONDS = 1000 * 60 * 60 * 6;

export const APP_PUBLIC_DOWNLOAD_URL = 'https://abr.ge/@doctornow';
export const APP_TRACKING_CHANNEL = 'web_organic';
export const APP_GENERAL_TRACKING_PARAMS =
  'og_tag_id=138187085&routing_short_id=d816rm&tracking_template_id=2b94e9766fea0e112f2b11b7410088c4&ad_type=click';

export const APP_STORE_PAGE_LINK_TRACKING_PARAMS =
  'og_tag_id=138187710&routing_short_id=pzm4azo&tracking_template_id=a82e9a369aeb09d88afb5812cf2376b6&ad_type=click';

export const APP_HAIRLOSS_TRACKING_PARAMS =
  'og_tag_id=285640949&routing_short_id=pqq5ys&tracking_template_id=36a9407528e07b0d2568b463fd573f57&ad_type=click';

export const APP_ACNE_TRACKING_PARAMS =
  'og_tag_id=285674496&routing_short_id=8r96pa&tracking_template_id=d9be8b6900b21be591266a35119e7e48&ad_type=click';

export const APP_DIET_TRACKING_PARAMS =
  'og_tag_id=285673148&routing_short_id=g0qaey&tracking_template_id=989bfe4cfb73e9b0a566efdcb6630496&ad_type=click';

export const TELEMEDICINE_SUBMENUS = [
  {
    text: '소아청소년과',
    url: getCategoryPath(TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS, EMedicalCategoryType.DEPARTMENT),
    categoryId: TELEMEDICINE_CATEGORY_IDS.DEPARTMENT.PEDIATRICS,
    categoryType: EMedicalCategoryType.DEPARTMENT,
  },
  {
    text: '감기/독감',
    url: getCategoryPath(TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD, EMedicalCategoryType.TREATMENT),
    categoryId: TELEMEDICINE_CATEGORY_IDS.TREATMENT.COLD,
    categoryType: EMedicalCategoryType.TREATMENT,
  },
  {
    text: '인공눈물',
    url: getCategoryPath(TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS, EMedicalCategoryType.TREATMENT),
    categoryId: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ARTIFICIAL_TEARS,
    categoryType: EMedicalCategoryType.TREATMENT,
  },
  {
    text: '탈모',
    url: getCategoryPath(TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS, EMedicalCategoryType.TREATMENT),
    categoryId: TELEMEDICINE_CATEGORY_IDS.TREATMENT.HAIRLOSS,
    categoryType: EMedicalCategoryType.TREATMENT,
  },
  {
    text: '여드름',
    url: getCategoryPath(TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE, EMedicalCategoryType.TREATMENT),
    categoryId: TELEMEDICINE_CATEGORY_IDS.TREATMENT.ACNE,
    categoryType: EMedicalCategoryType.TREATMENT,
  },
  {
    text: '전체 보기',
    url: ROUTES.TELEMEDICINE.CATEGORIES.path,
    categoryId: 'ALL',
    categoryType: null,
  },
];

export const HOSPITAL_SUBMENUS = [
  {
    text: '이비인후과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '이비인후과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '피부과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '피부과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '내과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '내과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '산부인과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '산부인과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '가정의학과',
    url:
      ROUTES.HOSPITAL.NEIGHBORHOOD.path +
      addQueryString({
        keyword: '가정의학과',
        regionCode: 11,
        type: 'all',
      }),
  },
  {
    text: '전체 보기',
    url: ROUTES.HOSPITAL.HOME.path,
  },
];

export const NON_BENEFIT_SUBMENUS = [
  {
    text: '탈모 진료비',
    url:
      ROUTES.NON_BENEFIT.HOME.path +
      addQueryString({
        treatmentId: TREATMENT_CATEGORIES_IDS.Hairloss,
        regionCode: SEOUL_REGION_CODE,
        treatmentMedicineUnitId: DEFAULT_HAIR_LOSS_TREATMENT_MEDICINE_UNIT_ID,
      }),
  },
  {
    text: '비만 진료비',
    url:
      ROUTES.NON_BENEFIT.HOME.path +
      addQueryString({
        treatmentId: TREATMENT_CATEGORIES_IDS.Diet,
        regionCode: SEOUL_REGION_CODE,
        treatmentMedicineUnitId: DEFAULT_DIET_TREATMENT_MEDICINE_UNIT_ID,
      }),
  },
  {
    text: '여드름 진료비',
    url:
      ROUTES.NON_BENEFIT.HOME.path +
      addQueryString({
        treatmentId: TREATMENT_CATEGORIES_IDS.Acne,
        regionCode: SEOUL_REGION_CODE,
        treatmentMedicineUnitId: DEFAULT_ACNE_TREATMENT_MEDICINE_UNIT_ID,
      }),
  },
  {
    text: '최저가 약국',
    url: ROUTES.NON_BENEFIT.MAP.path,
  },
];

export const MAGAZINE_SUBMENUS = [
  {
    text: '건강 매거진',
    url: ROUTES.MAGAZINE.LIST.path + '/INTERNAL',
  },
  {
    text: '1분 FAQ',
    url: ROUTES.FAQ.LIST.path,
  },
  {
    text: '의약품 사전',
    url: ROUTES.MEDICINE_DICTIONARY.HOME.path,
  },
  {
    text: '질환백과',
    url: ROUTES.DISEASE_ENCYCLOPEDIA.HOME.path,
  },
];

export const QNA_SUBMENUS = [
  {
    text: '실시간 질문',
    url: ROUTES.QNA.REALTIME.path,
  },
  {
    text: '질문하기',
    url: ROUTES.QNA.WRITE.path,
  },
];
